"use client";
import cx from "clsx";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-global-class-names/get-global-class-names.ts
const FOCUS_CLASS_NAMES = {
	always: "mantine-focus-always",
	auto: "mantine-focus-auto",
	never: "mantine-focus-never"
};
/** Returns classes that are defined globally (focus and active styles) based on options */
function getGlobalClassNames({ theme, options, unstyled }) {
	return cx(options?.focusable && !unstyled && (theme.focusClassName || FOCUS_CLASS_NAMES[theme.focusRing]), options?.active && !unstyled && theme.activeClassName);
}
//#endregion
export { FOCUS_CLASS_NAMES, getGlobalClassNames };

//# sourceMappingURL=get-global-class-names.mjs.map